/* import __COLOCATED_TEMPLATE__ from './modal.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { IMAGE_PLACEHOLDER_CIRCLE } from '@intercom/composer-ember/components/tools/media-inserter/constants';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
var Status = /*#__PURE__*/function (Status) {
  Status[Status["UNINITIALIZED"] = 0] = "UNINITIALIZED";
  Status[Status["UPLOADED"] = 1] = "UPLOADED";
  Status[Status["PENDING"] = 2] = "PENDING";
  Status[Status["FAILED"] = 3] = "FAILED";
  return Status;
}(Status || {});
let Modal = (_class = class Modal extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "title", _descriptor2, this);
    _initializerDefineProperty(this, "description", _descriptor3, this);
    _initializerDefineProperty(this, "imageUrl", _descriptor4, this);
    _initializerDefineProperty(this, "uploadStatus", _descriptor5, this);
    _initializerDefineProperty(this, "uploadErrorMessage", _descriptor6, this);
  }
  get composer() {
    return this.args.composer;
  }
  get canSubmit() {
    return Boolean(this.description) && this.uploadStatus === Status.UPLOADED;
  }
  get uploadedImageName() {
    if (this.uploadStatus === Status.UNINITIALIZED) {
      return '';
    }
    return this.imageUrl.split('/').pop();
  }
  get uploadButtonLabel() {
    switch (this.uploadStatus) {
      case Status.PENDING:
        return this.intl.t('prosemirror.components.tools.image-text-inserter.upload-image-button-label.uploading');
      case Status.UPLOADED:
        return this.intl.t('prosemirror.components.tools.image-text-inserter.upload-image-button-label.uploaded');
      default:
        return this.intl.t('prosemirror.components.tools.image-text-inserter.upload-image-button-label.default');
    }
  }
  handleSubmit() {
    let imageTextData = {
      type: 'imageText',
      imageUrl: this.imageUrl,
      title: this.title,
      text: this.description
    };
    this.args.onSubmit(imageTextData);
  }
  async handleUploadImage(file) {
    if (!file) {
      return;
    }
    try {
      this.uploadStatus = Status.PENDING;
      let uploadResult = await this.composer.commands.doUpload(file);
      switch (uploadResult.type) {
        case 'success':
          this.handleUploadSuccess(file, uploadResult.uploadUrl);
          break;
        case 'failure':
          // We should probably replace existing error message with a more meaningful one,
          // currently it says "something wrong", which is also what is used/displayed in the image block.
          // this.handleUploadFailure(uploadResult.reason);
          this.handleUploadFailure(this.intl.t('prosemirror.components.tools.image-text-inserter.upload-error-message'));
          break;
      }
    } catch (e) {
      this.handleUploadFailure(e.message);
    }
  }
  handleUploadSuccess(_file, uploadUrl) {
    this.imageUrl = uploadUrl;
    this.uploadStatus = Status.UPLOADED;
    this.uploadErrorMessage = '';
  }
  handleUploadFailure(reason = '') {
    this.uploadStatus = Status.FAILED;
    this.uploadErrorMessage = reason;
  }
  handleTitleChange(e) {
    this.title = e.target?.value;
  }
  handleDescriptionChange(e) {
    this.description = e.target?.value;
  }
  onKeyUp(e) {
    if (e.key === 'Enter' && this.canSubmit) {
      this.handleSubmit();
    } else if (e.code === 'Escape') {
      this.args.onClose();
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "title", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.initialTitle || '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "description", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.initialDescription || '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "imageUrl", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.initialImageUrl || IMAGE_PLACEHOLDER_CIRCLE;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "uploadStatus", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.isEditing ? Status.UPLOADED : Status.UNINITIALIZED;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "uploadErrorMessage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _applyDecoratedDescriptor(_class.prototype, "handleSubmit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleSubmit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleUploadImage", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleUploadImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleUploadSuccess", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleUploadSuccess"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleUploadFailure", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleUploadFailure"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleTitleChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleTitleChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleDescriptionChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleDescriptionChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onKeyUp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onKeyUp"), _class.prototype), _class);
export { Modal as default };